import { createContext, useState, useEffect } from 'react';


const defaultOrgConfigContext = {
  isSemEnabled: false,
};

export const OrgConfigContext = createContext(
  defaultOrgConfigContext,
);
// `window?.wbConfig.isSemEnabled = ...` is not legal JS — optional chaining cannot be an
// assignment target. swc rejects it; the old toolchain accepted it. Guarding explicitly
// preserves the original intent (and the original module-load-time side effect).
if (window.wbConfig) {
  window.wbConfig.isSemEnabled = true;
}
export const OrgConfigContextProvider = ({ children }) => {
  const [orgConfigContext, setOrgConfigContext] =
    useState(defaultOrgConfigContext);
  const { isSemEnabled } = window?.wbConfig ?? {};
  useEffect(() => {
    setOrgConfigContext({
      isSemEnabled: isSemEnabled ?? defaultOrgConfigContext.isSemEnabled,
    });
  }, [isSemEnabled]);

  return (
    <OrgConfigContext.Provider value={{ ...orgConfigContext }}>
      {children}
    </OrgConfigContext.Provider>
  );
};
